import { Injectable, EventEmitter } from '@angular/core';
import {
  BaseFpxDataService,
  CreateFn,
  FindAllFn,
  FindByKeyFn,
  HttpRequest,
  LookUpFn,
  ModifyFn,
  // PatchFn,
  CriteriaQuery,
  HttpProviderService,
  ILookUpData,
  LoadForm,
  // FpxIHttpOption
} from '@fpx/core';
import { IHttpSuccessPayload,ILookupResponse } from '@fpx/core';
import { add } from '@amcharts/amcharts4/.internal/core/utils/Array';
import { map, Observable, of,catchError } from 'rxjs';
 import { Rloapplication, RloapplicationMaintanence } from './rloapplication.model';
import { environment } from 'src/environments/environment';
import { UserService } from 'src/app/user.service';
import moment from 'moment';
import { CommonService } from 'src/app/common.service';
@Injectable({
  providedIn: 'root'
})
export class RloapplicationService implements BaseFpxDataService<any> {

  sortApplied:boolean=false;
  filterApplied:boolean=false;
  searchApplied:boolean=false;

  // criteriaQuery = new CriteriaQuery();
  criteriaQuery :any;
  HoldoutAmtstatus:boolean=false;

  //search form data
  searchValue:any;

  //sort form data
  sort_applicantName:string;
  sort_arn:string;
  sort_type:string;
  sort_period:string;
  sort_stage:string;
  sort_tat:string;

  //filter form data
  filter_applicantName:string;
  filter_arn:number;
  filter_type:any;
  filter_period:any;
  filter_stage:any;
  filter_tat:any;


  tabTitle:string;
  userId = sessionStorage.getItem('username');
  noData:boolean=false;

  //date for filter
  fromDate:string="2023-01-01";
  toDate:any= moment().format("YYYY-MM-DD");

  //filter form lookup data
  tatData:any;
  stageData:any;
  periodData:any;
  typeData:any;

  //column name to be searched
  // periodColumn:string='CTP.CREATED_ON';
  // stageColumn:string='T.FORMNAME';
  // tatColumn:string='BURST_TIME';
  typeColumn:string='Priority';
  periodColumn:string='CTP.CREATED_ON';
  stageColumn:string='T.FORMNAME';
  tatColumn:string='TAT_BURST_ON';
  applicantNameColumn:string='CUSTOMER_NAME';
  arnColumn:string='APP_REF_NUMBER';

 constructor(private _httpProvider : HttpProviderService,
  private _userService:UserService,
  public _commonService: CommonService
  ) { }
  lookup(key: unknown, httpOption?: Map<string | number | symbol, Map<string, any>>): LookUpFn<any> {
    throw new Error('Method not implemented.');
  }

  loadForm?(payload: any, httpOption?: Map<string | number | symbol, Map<string, any>>): LoadForm<any> {
    throw new Error('Method not implemented.');
  }
  create(payload: Rloapplication): CreateFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('POST');
      httpRequest.setResource('/rloapplication');
      let bodyContent = {"rloapplication":payload};
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest );
    };
  }

  findByKey(key: Rloapplication, ): FindByKeyFn<Rloapplication|null> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/rloapplication/{appRef}');
       httpRequest.addPathParameter('appRef', key.appRef);
      httpRequest.setMethod('GET');
      return this._httpProvider
        .invokeRestApi(httpRequest, )
        .pipe(map((res: IHttpSuccessPayload<any>) => res.body?.rloapplication ?? null),catchError((err:any) => {
              return of(null)
            }));

    };
  }

  modify(payload: Rloapplication, ): ModifyFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/rloapplication/{appRef}');
       httpRequest.addPathParameter('appRef', payload.appRef);
     httpRequest.setMethod('PUT');
      let bodyContent = {"rloapplication":payload};
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest);
    };
  }

   delete(payload: Rloapplication, ): ModifyFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/rloapplication/{appRef}');
       httpRequest.addPathParameter('appRef', payload.appRef);
     httpRequest.setMethod('DELETE');
      let bodyContent = {"rloapplication":payload};
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest);
    };
  }

  //  patch(payload: Rloapplication, ): PatchFn<any> {
  //   return () => {
  //     const httpRequest = new HttpRequest();
  //     httpRequest.setResource('/rloapplication/{appRef}');
  //      httpRequest.addPathParameter('appRef', payload.appRef);
  //    httpRequest.setMethod('PUT');
  //     let bodyContent = {"rloapplication":payload};
  //     httpRequest.setBody(bodyContent);
  //     return this._httpProvider.invokeRestApi(httpRequest, );
  //   };
  // }

 findAll(criteriaQuery?: CriteriaQuery, ): FindAllFn<RloapplicationMaintanence> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('GET');
      let fromDate = criteriaQuery?.getQueryparam('fromDate');

      if(this.tabTitle=='Pending') {
        httpRequest.setResource('/rloapplication/{userId}');
        // httpRequest.addPathParameter('userId', this.userId);
        httpRequest.addPathParameter('userId', 'USER');
      }
      else if(this.tabTitle=='TAT Burst') {
        httpRequest.setResource('/rloapplication');
        httpRequest.addQueryParameter('TAT','true');
      }
      else{
        httpRequest.setResource('/rloapplication');
      }
      // criteriaQuery.setPaginationCriteria('0',60);
      httpRequest.addQueryParameter('criteriaDetails',(JSON.stringify(criteriaQuery.criteriaQuery())));
      httpRequest.addQueryParameter('fromdate',this.fromDate);
      httpRequest.addQueryParameter('todate',this.toDate);
      if(this.tabTitle != 'TAT Burst' && JSON.stringify(criteriaQuery.criteriaQuery()).indexOf(this.tatColumn) >= 0){
        httpRequest.addQueryParameter('TAT','true');
      }
      httpRequest.setServerContext(environment.customersPublisher);
      return this._httpProvider.invokeRestApi(httpRequest).pipe(
          map(
            (res: IHttpSuccessPayload<RloapplicationMaintanence>) =>{
              this.noData = false;
              let offset = criteriaQuery.criteriaQuery().Offset || 0;
              if(Number(offset) < 10 && !res.body) {
                this.noData = true;
              }
              // if(res.body) this.noData=false;
              // else {
              //   if((<HTMLElement>document.querySelector('app-rlo-application-display-grid')).offsetHeight < 500)
              //   this.noData=true;
              // }
              this._commonService.hideSpinner();
             return{
              data:res.body?.rloapplication || [],
              totalRowCount: res.body?.totalRowCount
              }
            }
          ),catchError((err:any) => {
            this._commonService.hideSpinner();
            this.noData=true;
            return of(null)
          })
        );
    };
  }


  // lookup(key: any, criteriaQuery?: CriteriaQuery | undefined): LookUpFn<any> {
  //   return () => {
  //   const httpRequest = new HttpRequest();
  //   httpRequest.setMethod('GET');
  //   httpRequest.setResource('/rloapplication');
  //   httpRequest.addQueryParameter('lookup', 1);
  //   if(criteriaQuery){
  //       criteriaQuery?.addFilterCritertia('text','String','Contains',{
  //         searchText : key.searchText
  //       })
  //       httpRequest.setCriteriaQuery(criteriaQuery)
  //    }
  //   return this._httpProvider.invokeRestApi(httpRequest, ).pipe(
  //       map((res: IHttpSuccessPayload<ILookupResponse>) => {
  //         return res.body?.Data || [];
  //       })
  //     );
  //   };
  // }

  fetchStatistics(criteriaQuery: CriteriaQuery, ): FindAllFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource("/rloapplication/statistics");
      httpRequest.setMethod("GET");
      httpRequest.setCriteriaQuery(criteriaQuery);
      return this._httpProvider
        .invokeRestApi(httpRequest )
        .pipe(map((res: IHttpSuccessPayload<any>) => res.body));
    };
  }
  getChartData(criteriaQuery: CriteriaQuery): Observable<any> {
    const httpRequest = new HttpRequest();
    httpRequest.setResource('/rloapptrends/{userId}');
    // httpRequest.addPathParameter('userId', this.userId);
    httpRequest.addPathParameter('userId', 'USER');
    httpRequest.setServerContext(environment.customersPublisher);
    httpRequest.setMethod('GET');
    httpRequest.addQueryParameter("fromdate", this.fromDate);
    httpRequest.addQueryParameter("todate", this.toDate);
    // httpRequest.setCriteriaQuery(criteriaQuery);
    return this._httpProvider
     .invokeRestApi(httpRequest)
     .pipe(
      map(
       (res: IHttpSuccessPayload<any>) =>
        res.body
      )
     );
   };
   getAppSummary(criteriaQuery?: CriteriaQuery): Observable<any> {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/rloappsummary/{userId}');
      // httpRequest.addPathParameter('userId', this.userId);
      httpRequest.addPathParameter('userId', 'USER');
      httpRequest.setServerContext(environment.customersPublisher);
      httpRequest.setMethod('GET');
      httpRequest.addQueryParameter("fromdate", this.fromDate);
    httpRequest.addQueryParameter("todate", this.toDate);
      return this._httpProvider
       .invokeRestApi(httpRequest)
       .pipe(
        map(
         (res: IHttpSuccessPayload<any>) =>
          res.body
        )
       );
     };
}
